export default __webpack_public_path__ + "static/media/suitcase_closed.2ff07a03.png";